import { api } from '@/api';
import { DOCUMENT_TYPE } from '@/features/documents/constants';
import type { CvAssessmentDetails } from '@/features/bid-cvs/types';
import { queryOptions } from '@tanstack/react-query';
import { CvAssessmentStatus } from '@/features/bid-cvs/constants';
import { REFETCH_SUMMARIZATION_INTERVAL } from '@/features/workspaces/constants';

export const bidCvDetailsQuery = (bidId: string) =>
  queryOptions({
    queryKey: ['bidCvDetails', bidId],
    queryFn: async () =>
      (
        await api.get<CvAssessmentDetails>('v1/analysis/cv_analysis', {
          params: { type: DOCUMENT_TYPE.bid, resourceId: bidId },
        })
      ).data,
    refetchInterval: (query) =>
      query.state.data?.status === CvAssessmentStatus.IN_PROGRESS
        ? REFETCH_SUMMARIZATION_INTERVAL * 1000
        : false,
  });
